import { render, staticRenderFns } from "./MypageTicketTodayCardSection.vue?vue&type=template&id=68510b87&scoped=true"
import script from "./MypageTicketTodayCardSection.vue?vue&type=script&lang=ts"
export * from "./MypageTicketTodayCardSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketTodayCardSection.vue?vue&type=style&index=0&id=68510b87&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68510b87",
  null
  
)

export default component.exports